import React, { useContext } from 'react';
import context from '../context';
import styled from 'styled-components';

const Logo = styled.img`
  //min-width: 250px;
  min-height: 150px;
  max-width: 250px;
  max-height: 150px;
  object-fit: contain;
  object-position: center;
  margin-top: 1rem; // Ajusta este valor según necesites
`;

export default ({ dark, mobile })=> {
  const state = useContext(context);
  return(
      <Logo src={dark ? state.logoDark : mobile ? require("../images/logo2.png") : state.logo} alt="Logo" />
  )
}